import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card text-dark bg-warning"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-body" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "card-title text-dark" }, "No Applicable Programs"),
  /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning" }, " You do not qualify for any awards at this time. Please check again later or modify your search by clicking 'Search Again'. ")
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "card text-start"
}
const _hoisted_5 = { class: "card-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-title h2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-usd-circle text-success" }),
  /*#__PURE__*/_createTextVNode(" Potential Programs Available")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "lead" }, " Thank you for taking the time to determine what financial aid opportunities might be available to you. ", -1)
const _hoisted_8 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_9 = { class: "alert alert-success rounded mt-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-check-circle fa-lg fa-fw me-1" }),
  /*#__PURE__*/_createTextVNode(" Qualifying Programs")
], -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Based upon the information you submitted, you may qualify for the following program(s): ")
const _hoisted_12 = { class: "table table-responsive my-1" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ADHE Program"),
  /*#__PURE__*/_createElementVNode("th", {
    scope: "col",
    class: "text-end"
  }, "Amount")
], -1)
const _hoisted_14 = { scope: "row" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("th", { scope: "row" }, [
  /*#__PURE__*/_createTextVNode("Possible first-year amount"),
  /*#__PURE__*/_createElementVNode("sup", null, "*"),
  /*#__PURE__*/_createTextVNode(":")
], -1)
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 mt-0 ps-2" }, [
  /*#__PURE__*/_createElementVNode("sup", null, "*"),
  /*#__PURE__*/_createTextVNode("Based on full-time enrollment")
], -1)
const _hoisted_21 = {
  key: 0,
  class: "fs-6 mt-0 ps-2"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("sup", null, "**", -1)
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Academic Challenge and Governor's Scholar Awards do not stack.")
const _hoisted_24 = [
  _hoisted_22,
  _hoisted_23
]
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "alert alert-primary rounded mt-3" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-calendar-exclamation fa-lg fa-fw me-1" }),
  /*#__PURE__*/_createTextVNode(" Upcoming Programs")
], -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" You may qualify for the following program(s) that are yet to be open for applications. ")
const _hoisted_29 = { class: "table table-responsive" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ADHE Program"),
  /*#__PURE__*/_createElementVNode("th", {
    class: "text-center",
    scope: "col"
  }, "Date"),
  /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Amount")
], -1)
const _hoisted_31 = { scope: "row" }
const _hoisted_32 = { class: "text-center" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" Please check back after the opening date(s) to apply. ")
const _hoisted_35 = { key: 2 }
const _hoisted_36 = { class: "alert alert-primary rounded mt-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h5", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fad fa-exclamation-triangle fa-lg fa-fw me-1" }),
  /*#__PURE__*/_createTextVNode(" Unable to Apply")
], -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" You may qualify for the following programs, but are unable to apply for the following reasons: ")
const _hoisted_39 = { class: "table table-responsive" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "ADHE Program"),
  /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Reason")
], -1)
const _hoisted_41 = { scope: "row" }
const _hoisted_42 = {
  key: 3,
  class: "mt-2"
}
const _hoisted_43 = /*#__PURE__*/_createTextVNode(" You now have two options: ")
const _hoisted_44 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("ul", null, [
    /*#__PURE__*/_createElementVNode("li", null, "Click \"Continue\" below to apply for these scholarships. If you exit prior to logging in or creating a SAMS account, your financial aid search results will not be saved."),
    /*#__PURE__*/_createElementVNode("li", null, "Modify your search by clicking “Search Again”.")
  ])
], -1)
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = { class: "text-center mt-4" }
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Search Again")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("Continue")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_activity_button = _resolveComponent("activity-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.applicationInProgress!.qualificationResults!.length == 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            (_ctx.qualfiesForOpenPrograms)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _hoisted_11,
                    _createElementVNode("table", _hoisted_12, [
                      _hoisted_13,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationInProgress!.qualificationResults!.filter(v => v.result == _ctx.QualificationResultEnum.QualfiedToApply), (qp) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: qp.abbreviation
                          }, [
                            _createElementVNode("td", _hoisted_14, _toDisplayString(qp.displayName), 1),
                            _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.awardAmountFormatted(qp)), 1)
                          ]))
                        }), 128))
                      ]),
                      (_ctx.totalPotentialAward)
                        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_16, [
                            _createElementVNode("tr", null, [
                              _hoisted_17,
                              _createElementVNode("td", _hoisted_18, [
                                (_ctx.isQualifiedForACSAndGS)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_19, "**"))
                                  : _createCommentVNode("", true),
                                _createTextVNode(" " + _toDisplayString(_ctx.totalPotentialAward), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _hoisted_20,
                    (_ctx.isQualifiedForACSAndGS)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, _hoisted_24))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.qualfiesForClosedPrograms)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _hoisted_27,
                    _hoisted_28,
                    _createElementVNode("table", _hoisted_29, [
                      _hoisted_30,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.applicationInProgress!.qualificationResults!!.filter(v => v.result === _ctx.QualificationResultEnum.ApplicationWindowNotYetOpen), (qp) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: qp.abbreviation
                          }, [
                            _createElementVNode("td", _hoisted_31, _toDisplayString(qp.displayName), 1),
                            _createElementVNode("td", _hoisted_32, _toDisplayString(_ctx.dateTimeFormatters.toShortDate(_ctx.jsonStringToDate(qp.applicationStartDate))), 1),
                            _createElementVNode("td", _hoisted_33, _toDisplayString(_ctx.awardAmountFormatted(qp)), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _hoisted_34
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.otherDisqualifiedPrograms.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _hoisted_38,
                    _createElementVNode("table", _hoisted_39, [
                      _hoisted_40,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherDisqualifiedPrograms, (qp) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: qp.abbreviation
                          }, [
                            _createElementVNode("td", _hoisted_41, _toDisplayString(qp.displayName), 1),
                            _createElementVNode("td", null, _toDisplayString(qp.disqualificationReason), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.qualfiesForOpenPrograms)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
              : _createCommentVNode("", true)
          ])
        ])),
    _createElementVNode("div", _hoisted_46, [
      _createVNode(_component_router_link, {
        class: "btn btn-outline-primary",
        to: { name: 'Public/Search/Home' }
      }, {
        default: _withCtx(() => [
          _hoisted_47
        ]),
        _: 1
      }),
      (_ctx.qualfiesForOpenPrograms)
        ? (_openBlock(), _createBlock(_component_activity_button, {
            key: 0,
            "click-handler": _ctx.apply,
            class: "btn btn-primary ms-2"
          }, {
            default: _withCtx(() => [
              _hoisted_48
            ]),
            _: 1
          }, 8, ["click-handler"]))
        : _createCommentVNode("", true),
      (_ctx.loggedIn)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-secondary ms-2",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goHome()))
          }, "Return to My Account"))
        : (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: "btn btn-secondary ms-2",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goHome()))
          }, "Return to SAMS Login Page"))
    ])
  ]))
}